module.exports = __webpack_public_path__ + "img/DK37760412.42edfe8a.png";